export const HelpCenterReducer = (state, action) => {
    switch (action.type) {
        case "SET_HELPCENTER_FOR":
            return {
                ...state,
                helpCenterFor: action.payload,
                showRatingDialog: false,
                showSubmitIdeaDialog:false,
                showDetailComponent: false,
                showContactUsOptions: false,
                showContactUsDetail: false,
                selectedVideoArticle: {},
                contactUsMethod: ""
            };
        case "SET_USER":
            return {
                ...state,
                user: action.payload
            };
        case "TOGGLE_RATING_DIALOG":
            return {
                ...state,
                showRatingDialog: !state.showRatingDialog
            }
        case "TOGGLE_SUBMITIDEA_DIALOG":
            return {
                ...state,
                showSubmitIdeaDialog: !state.showSubmitIdeaDialog
            }  
        case "SET_DATAITEM":
            return {
                ...state,
                dataItem: action.payload
            };
        case "SET_SEARCH_KEYWORD":
            return {
                ...state,
                searchKeyword: action.payload.searchKeyword,
                searchResult: action.payload.searchResult
            };
        case "TOGGLE_DETAIL_COMPONENT":
            return {
                ...state,
                showDetailComponent: true,
                selectedVideoArticle: action.payload,
                showContactUsOptions: false
            };
        case "TOGGLE_CONTACTUS_OPTIONS":
            return {
                ...state,
                showDetailComponent: false,
                showContactUsOptions: !state.showContactUsOptions,
                selectedVideoArticle: {}
            }
        case "TOGGLE_HELPCENTER":
            return {
                ...state,
                showHelpCenter: !state.showHelpCenter
            }
        case "TOGGLE_CONTACT_DETAIL":
            return {
                ...state,
                showContactUsDetail: !state.showContactUsDetail,
                contactUsMethod: action.payload
            }
        case "BACK_TO_HOME":
            return {
                ...state,
                showDetailComponent: false,
                selectedVideoArticle: {},
                showContactUsOptions: state.showContactUsDetail ? true : false,
                showContactUsDetail: false,
                contactUsMethod: ""
            }
        default:
            return state
    }
};